import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BenefitDTO } from '../../../../models/benefit.dto';

@Injectable({ providedIn: 'root' })
export class AddBenefitService {
  public benefitAdded$ = new Subject<BenefitDTO>();
  public initial: BenefitDTO;
}
